import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'

export const selectShouldFetch = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.CompanyStore.fetched
  ],
  (fetched) => !fetched
)

// select companies keyed by id
export const selectCompaniesData = createSelector(
  [(state: ApplicationState) => state.CompanyStore.data],
  (data) => data
)

export const selectCompaniesFetched = createSelector(
  [(state: ApplicationState) => state.CompanyStore.fetched],
  (fetched) => fetched
)
